import { OfferApiState } from '../../../../constants';

export const stateFilterOptions = [
  {
    value: OfferApiState.All,
    title: 'All',
  },
  {
    value: OfferApiState.Active,
    title: 'Active',
  },
  {
    value: OfferApiState.Inactive,
    title: 'Inactive',
  },
];
